import { render, staticRenderFns } from "./Notes.vue?vue&type=template&id=23c4bb4f&"
import script from "./Notes.vue?vue&type=script&lang=js&"
export * from "./Notes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/c6monbi/assets/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('23c4bb4f')) {
      api.createRecord('23c4bb4f', component.options)
    } else {
      api.reload('23c4bb4f', component.options)
    }
    module.hot.accept("./Notes.vue?vue&type=template&id=23c4bb4f&", function () {
      api.rerender('23c4bb4f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "js/monbi/settings/employees/Notes.vue"
export default component.exports